(() => {
  if (customElements.get('soho-help-editorial')) return;
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  class SohoHelpEditorial extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.root = this.closest('[data-sh-root]');
      this.search = this.querySelector('[data-sh-search]');
      this.clear = this.querySelector('[data-sh-clear]');
      this.select = this.querySelector('[data-sh-select]');
      this.status = this.querySelector('[data-sh-status]');
      this.empty = this.querySelector('[data-sh-empty]');
      this.buttons = [...this.querySelectorAll('[data-sh-category]')];
      this.groups = [...this.querySelectorAll('[data-sh-group]')];
      this.questions = [...this.querySelectorAll('[data-sh-question]')].map(node => ({ node, slug: node.dataset.shQuestion, category: node.dataset.shQuestionCategory, text: normalize(node.textContent) }));
      this.category = 'shipping';
      if (!this.search || !this.questions.length) return;
      this.root.classList.add('is-enhanced');
      this.querySelectorAll('[data-sh-enhanced]').forEach(node => { node.hidden = false; });
      this.search.addEventListener('input', () => this.render(), options);
      this.clear.addEventListener('click', () => { this.search.value = ''; this.render(); this.search.focus(); }, options);
      this.buttons.forEach(button => button.addEventListener('click', () => this.chooseCategory(button.dataset.shCategory), options));
      this.select.addEventListener('change', () => this.chooseCategory(this.select.value), options);
      this.addEventListener('toggle', event => {
        const question = this.questions.find(item => item.node === event.target);
        if (!question || this.hasAttribute('data-sh-editor')) return;
        const url = new URL(window.location.href);
        if (question.node.open) {
          url.searchParams.set('question', question.slug);
          if (url.hash && url.hash !== `#${question.slug}`) url.hash = '';
        } else if (url.searchParams.get('question') === question.slug) {
          url.searchParams.delete('question');
          if (url.hash === `#${question.slug}`) url.hash = '';
        }
        else return;
        window.history.replaceState(null, '', url);
      }, { ...options, capture: true });
      window.addEventListener('popstate', () => this.openFromUrl(), options);
      window.addEventListener('hashchange', () => this.openFromUrl(), options);
      this.addEventListener('shopify:block:select', event => {
        const question = this.questions.find(item => item.node.dataset.shBlock === event.detail.blockId);
        if (question) this.reveal(question);
      }, options);
      this.render();
      this.openFromUrl();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    chooseCategory(category) {
      if (!this.groups.some(group => group.dataset.shGroup === category)) return;
      this.category = category;
      this.search.value = '';
      const url = new URL(window.location.href);
      url.searchParams.delete('question');
      if (this.questions.some(question => `#${question.slug}` === url.hash)) url.hash = '';
      if (!this.hasAttribute('data-sh-editor')) window.history.replaceState(null, '', url);
      this.render();
    }
    render() {
      const query = normalize(this.search.value.trim());
      const words = query.split(/\s+/).filter(Boolean);
      let count = 0;
      this.questions.forEach(question => {
        const visible = words.length ? words.every(word => question.text.includes(word)) : question.category === this.category;
        question.node.hidden = !visible;
        if (visible) count++;
      });
      this.groups.forEach(group => { group.hidden = !this.questions.some(question => question.node.closest('[data-sh-group]') === group && !question.node.hidden); });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(!query && button.dataset.shCategory === this.category)));
      this.select.value = query ? '' : this.category;
      this.clear.hidden = !query;
      this.empty.hidden = count > 0;
      this.root.classList.toggle('is-searching', Boolean(query));
      const template = query ? (count === 1 ? this.dataset.resultsSearchOne : this.dataset.resultsSearch) : count === 1 ? this.dataset.resultsOne : this.dataset.resultsMany;
      this.status.textContent = template.replace('[count]', String(count)).replace('[query]', this.search.value.trim());
    }
    openFromUrl() {
      const url = new URL(window.location.href);
      let slug = url.searchParams.get('question');
      if (url.hash) {
        let hashSlug;
        try { hashSlug = decodeURIComponent(url.hash.slice(1)); } catch { return; }
        if (!this.questions.some(item => item.slug === hashSlug)) return;
        slug = hashSlug;
      }
      const question = this.questions.find(item => item.slug === slug);
      if (question) this.reveal(question);
    }
    reveal(question) {
      this.category = question.category;
      this.search.value = '';
      this.render();
      question.node.open = true;
      const summary = question.node.querySelector('summary');
      summary.focus({ preventScroll: true });
      question.node.scrollIntoView({ block: 'start' });
    }
  }
  customElements.define('soho-help-editorial', SohoHelpEditorial);
})();
